import api, { centreApi, V2 } from './axios';

/** Mirrors recovry_payouts.domain on the backend. */
export type PayoutStatus = 'not_started' | 'pending_verification' | 'active' | 'rejected';

export interface Payout {
  status: PayoutStatus;
  locked: boolean;
  can_edit: boolean;
  /** Full UPI id — only ever returned to the owning clinic. */
  vpa: string | null;
  vpa_masked: string | null;
  holder_name: string | null;
  /** Never the full PAN; the backend does not store it. */
  pan_masked: string | null;
  vendor_id: string | null;
  locked_at: string | null;
  updated_at: string | null;
  change_contact: string;
  rejection_reason: string | null;
}

export interface PayoutInput {
  vpa: string;
  holder_name: string;
  pan: string;
}

export interface AdminPayoutRow extends Payout {
  centre_id: string;
  centre_name: string | null;
  city: string | null;
  centre_email: string | null;
}

/** Shape of a 4xx/5xx body from the payouts endpoints. */
export interface PayoutApiError {
  code?: 'invalid_field' | 'settlement_locked' | 'provider_error' | 'rate_limited' | string;
  field?: keyof PayoutInput | 'reason';
  error?: string;
  contact_email?: string;
}

export const payoutsApi = {
  // Clinic (centre token)
  getMine: () => centreApi.get<{ payout: Payout }>(`${V2}payouts/me/`),
  setup: (input: PayoutInput) => centreApi.post<{ payout: Payout }>(`${V2}payouts/me/`, input),

  // Admin (user token)
  adminList: (status?: PayoutStatus) =>
    api.get<{ payouts: AdminPayoutRow[]; count: number }>(`${V2}payouts/admin/`, {
      params: status ? { status } : {},
    }),
  adminChange: (centreId: string, input: PayoutInput & { reason: string }) =>
    api.post<{ payout: Payout }>(`${V2}payouts/admin/${encodeURIComponent(centreId)}/change/`, input),
};

export const PAYOUT_STATUS_LABEL: Record<PayoutStatus, string> = {
  not_started: 'Not set up',
  pending_verification: 'Verifying',
  active: 'Active',
  rejected: 'Action needed',
};
